import { Box, Button, Container } from "@mui/material";
import ToastMessage from "../components/ToastMessage";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function MailSendPage() {
  const { t } = useTranslation(); 
  return (
    <Container sx={{ p: 4, bgcolor: "transparent" }}>
      <ToastMessage />
      <Box sx={{ p: 5 }}>
        <Button component={Link} variant="text" to="/" sx={{ color: '#fff' }}>{t("navigation.home")}</Button>
      </Box>
    </Container>
  )
}

export default MailSendPage;

